module.exports = __webpack_public_path__ + "static/media/money-bill-wave.5a877ccb.svg";